import { components, OptionProps } from 'react-select'
import { FC } from 'react'
import cx from 'classnames'
import { Option } from '../../../../lib/options'

type Props = OptionProps<Option, any>

export const CustomOption: FC<Props> = props => {
  const option = props.data as Option

  return (
    <components.Option {...props}>
      <span data-test={composeDataTest(option)} {...props.innerProps} ref={props.innerRef}>
        {props.children}
      </span>
    </components.Option>
  )
}

const composeDataTest = (option: Option): string => {
  return cx(
    'option', // I <3 PRETTIER
    option.__isNew__ && `new-option`,
    `option--${option.dataTest || option.value}`
  )
}

export type CustomOptionProps = Props
